import Vue from 'vue';

// 快递时效管理 跳转到 时效历史数据更新
export const EventBus = new Vue();
